import { takeEvery } from 'redux-saga/effects';

import * as paymentMethodsActionTypes from 'store/modules/paymentMethods/actionTypes';
import { remove } from './utils';

export default function* listenRemove() {
  yield takeEvery(paymentMethodsActionTypes.REMOVE, remove);
}
